
export const openLeftPanel = () => {
    document.getElementById('pnlLeft').classList.remove('d-none');
    setTimeout(() => {
        document.getElementById('pnlLeft').classList.add('map-panel-slideright');
        document.getElementById('pnlLeft').classList.remove('map-panel-slideright-hide');
    }, 0);
};

export const hideLeftPanel = () => {
    document.getElementById('pnlLeft').classList.add('map-panel-slideright-hide')
    setTimeout(() => {
        document.getElementById('pnlLeft').classList.add('d-none');
    }, 500);
};

export const openRightPanel = () => {
    document.getElementById('pnlRight').classList.remove('d-none');
    setTimeout(() => {
        document.getElementById('pnlRight').classList.add('map-panel-slideleft');
        document.getElementById('pnlRight').classList.remove('map-panel-slideleft-hide');
    }, 0);
};

export const hideRightPanel = () => {
    document.getElementById('pnlRight').classList.add('map-panel-slideleft-hide')
    setTimeout(() => {
        document.getElementById('pnlRight').classList.add('d-none');
    }, 500);
};